import * as React from 'react'

const SvgSearch = (props) => (
  <svg
    width={30}
    height={30}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='m26.768 23.233-3.502-3.502a11.28 11.28 0 0 1-3.535 3.535l3.502 3.502a2.5 2.5 0 1 0 3.535-3.535Z'
      fill='#101AA1'
    />
    <path
      opacity={0.35}
      d='M13.75 25C19.963 25 25 19.963 25 13.75S19.963 2.5 13.75 2.5 2.5 7.537 2.5 13.75 7.537 25 13.75 25Z'
      fill='#101AA1'
    />
  </svg>
)

export default SvgSearch
